import {MainMenuItem} from './main-menu-item.model';
import {Injectable} from '@angular/core';
import {Constants} from '../../../util/Constants';
import {HelperFunctions} from '../../../util/HelperFunctions'

@Injectable()
export class MainMenu {

  public MainMenuItems: MainMenuItem[] = [
    {
      title: 'Main',
      icon: '',
      active: true,
      groupTitle : true,
      sub: '',
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: [Constants.CAN_DO_ALL, Constants.CAN_VIEW_TRANSACTIONS, Constants.CAN_VIEW_SYSTEM_REPORT]
    },
    {
      title: 'Dashboard',
      icon: 'fa fa-dashboard',
      active: false,
      groupTitle: false,
      sub: '',
      routing: '/admin/dashboard',
      externalLink: '',
      budge: '',
      budgeColor: '#f44236',
      permissions: [Constants.CAN_DO_ALL, Constants.CAN_VIEW_TRANSACTIONS, Constants.CAN_VIEW_SYSTEM_REPORT]
    },
    {
      title: 'Funding',
      icon: 'fa fa-money',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Quick Funding',
          routing: '/admin/quick-funding',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_FUND_AGENT, Constants.CAN_FUND_WALLET]
        },
        {
          title: 'Fund Agents',
          routing: '/admin/fund-agents',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_FUND_AGENT, Constants.CAN_FUND_WALLET]
        },
        {
          title: 'Fund Requests',
          routing: '/admin/fund-requests',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_FUND_AGENT, Constants.CAN_FUND_WALLET]
        },
        {
          title: 'Fund History',
          routing: '/admin/fund-history',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_FUND_AGENT, Constants.CAN_FUND_WALLET]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    },
    {
      title: 'User Management',
      icon: '',
      active: false,
      groupTitle : true,
      sub: '',
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: [Constants.CAN_DO_ALL, Constants.CAN_CREATE_ADMIN, Constants.CAN_UPDATE_ADMIN, Constants.CAN_CREATE_AGENT ]
    },

    {
      title: 'Admins',
      icon: 'fa fa-user-secret',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Create',
          routing: '/admin/create-admin',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_CREATE_ADMIN]
        },
        {
          title: 'Manage',
          routing: '/admin/manage-admin',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_UPDATE_ADMIN]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    },
    {
      title: 'Agents',
      icon: 'fa fa-users',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Create',
          routing: '/admin/create-user',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_CREATE_AGENT]
        },
        {
          title: 'Manage',
          routing: '/admin/manage-agents',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_UPDATE_AGENT]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    },
    {
      title: 'Customers',
      icon: 'fa fa-users',
      active: false,
      groupTitle: false,
      sub: '',
      routing: '/admin/manage-customers',
      externalLink: '',
      budge: '',
      budgeColor: '#f44236',
      permissions: ''
    },
    {
      title: 'Frozen Transactions',
      icon: 'fa fa-pause',
      active: false,
      groupTitle: false,
      sub: '',
      routing: '/admin/frozen-accounts',
      externalLink: '',
      budge: '',
      budgeColor: '#f44236',
      permissions: ''
    },
    {
      title: 'Reports',
      icon: '',
      active: false,
      groupTitle : true,
      sub: '',
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: [Constants.CAN_DO_ALL, Constants.CAN_VIEW_TRANSACTIONS]
    },
    {
      title: 'Transactions',
      icon: 'fa fa-exchange',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Airtime',
          routing: '/admin/airtime-transactions',
          permissions: ''
        },
        {
          title: 'Data',
          routing: '/admin/data-transactions',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_VIEW_TRANSACTIONS, Constants.CAN_VIEW_SYSTEM_REPORT]
        },
        {
          title: 'Wallet',
          routing: '/admin/wallet-transactions',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_VIEW_TRANSACTIONS, Constants.CAN_VIEW_SYSTEM_REPORT]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    },

    {
      title: 'Settings',
      icon: '',
      active: false,
      groupTitle : true,
      sub: '',
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: [Constants.CAN_DO_ALL, Constants.CAN_SYSTEM_SETTINGS, Constants.CAN_CREATE_ROLE, Constants.CAN_UPDATE_ROLE]
    },

    {
      title: 'Role Management',
      icon: 'fa fa-sitemap',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Create Role',
          routing: '/admin/create-role',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_CREATE_ROLE]
        },
        {
          title: 'Manage Role',
          routing: '/admin/manage-role',
          permissions: [Constants.CAN_DO_ALL, Constants.CAN_UPDATE_ROLE]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    },
    {
      title: 'Configuration',
      icon: 'fa fa-wrench',
      active: false,
      groupTitle: false,
      sub: [
        {
          title: 'Networks Configuration',
          routing: '/admin/manage-networks',
          permissions: [Constants.CAN_SYSTEM_SETTINGS]
        },
        {
          title: 'Transaction Limit',
          routing: '/admin/transactions-configuration',
          permissions: [Constants.CAN_SYSTEM_SETTINGS]
        },
      ],
      routing: '',
      externalLink: '',
      budge: '',
      budgeColor: '',
      permissions: ''
    }

    // {
    //   title: 'System Configuration',
    //   icon: 'fa fa-wrench',
    //   active: false,
    //   groupTitle: false,
    //   sub: [
    //     {
    //       title: 'Networks',
    //       routing: '/admin/manage-networks',
    //       permissions: [Constants.CAN_DO_ALL, Constants.CAN_CREATE_ROLE]
    //     },
    //   ],
    //   routing: '',
    //   externalLink: '',
    //   budge: '',
    //   budgeColor: '',
    //   permissions: ''
    // },

  ]

// Empty Array to construct the menu based on valid permissions

  public permissions: any[] = [];

  private MAINMENUITEMS: MainMenuItem[];
  private permissionValues: String[] = [];
  private user: any;


  constructor() {
  }

  private getPermissions(): any[] {
    const permissions: any[] = [];
    const userPermissions : any[] = [];
    this.user = JSON.parse(localStorage.getItem(Constants.PROFILE)).data[0];
    // get permissions from local storage// console.log('get user permissions')
    // console.log(this.user.permissions[0].name);

    this.permissions = this.user.permissions.forEach((permission) => {
      permissions.push(permission.name);
    })
    return permissions;
  }

  private getMenuOptions() {
    const sidebar_menu: MainMenuItem[] = [];
    let counter = 0;
    let labels = 0;
    let menus = 0;
    let menu_with_submenu = 0;
    // get permissions
    this.getPermissions();
    // console.log('permissions');
    // loop through the menu items to construct
    for (const menu of this.MainMenuItems) {
      counter++;
      // labels with permissions that exists
      if (menu.permissions == 0 || (menu.groupTitle && HelperFunctions.isElementsExistsInArray(menu.permissions, this.getPermissions()))) {
        sidebar_menu.push(menu);
        labels++;
      }
      // menu that has submenus && permissions exists
      else if (menu.sub !== '') {
        const newsub: any[] = [];
        for (const sub_items of menu.sub) {
          if (HelperFunctions.isElementsExistsInArray(sub_items.permissions, this.getPermissions())) {
            newsub.push(sub_items);
          }
        }
        if (newsub.length > 0) {
          menu.sub = newsub;
          sidebar_menu.push(menu);
          menu_with_submenu++;
        }
      }
      // menu without submenus && permissions exists
      else if (menu.permissions == 0 || ((menu.sub === '') && (HelperFunctions.isElementsExistsInArray(menu.permissions, this.getPermissions() )))) {
        sidebar_menu.push(menu);
        menus++;
      }
    }
    this.MAINMENUITEMS = sidebar_menu;
    // console.log("side bar menu starts");
    // console.log('counter '+ counter);
    // console.log('labels '+ labels);
    // console.log('menus '+ menus);
    // console.log('menu with submenu'+ menu_with_submenu);
  }

  public getMainMenuItems() {
    this.getMenuOptions();
    return this.MAINMENUITEMS;
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/menus/main-menu/mock-main-menu-items.ts